module.exports = "<div class=\"slider\" ng-hide=\"$root.isMember\">\n  <div class=\"centerwrap clear\">\n    <div id=\"banner-fade\">\n      <ul class=\"caption\">\n        <li ng-repeat=\"item in main.siteConst.advert.tour\">{{item}}</li>\n      </ul>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/core_theme_3/src/templates/directives/slider.html
// module id = 157
// module chunks = 0